import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {  FaMobileAlt, FaHeadphones, FaPlug, FaMicrochip } from "react-icons/fa";
import "../styles/HeroSection.css";

const Home = () => {
  return (
    <div id="home" className="hero-section text-white d-flex align-items-center justify-content-center">
      {/* Background Image */}
      <div className="hero-bg"></div>

      {/* Hero Content */}
      <Container className="text-center text-light mt-5 pt-5">
        <h1>Welcome to Bhanot International LLC !</h1>
        <p>Your Trusted Global Wholesale Partner for Mobile Phones & Electronics</p>
        <p>We specialize in high-quality, competitively priced wholesale products, serving businesses worldwide. Our product range includes:
</p>

        {/* Icons Section */}
        <Row className="icon-row">
          <Col xs={6} md={3} lg={1}>
            <div className="icon-box">
              <FaMobileAlt className="hero-icon" />
              <p>Mobile Phones (New and Used)</p>
            </div>
          </Col>
          <Col xs={6} md={3} lg={1}>
            <div className="icon-box">
              <FaHeadphones className="hero-icon" />
              <p>Accessories</p>
            </div>
          </Col>
          <Col xs={6} md={3} lg={1}>
            <div className="icon-box">
              <FaPlug className="hero-icon" />
              <p>Consumer Electronics</p>
            </div>
          </Col>
          <Col xs={6} md={3} lg={1}>
            <div className="icon-box">
              <FaMicrochip className="hero-icon" />
              <p>Tech & IT Accessories</p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Home;
